import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import InfiniteScroll from 'react-infinite-scroller';
import { Redirect } from 'react-router-dom';
import sh from '../../../../helpers/string.helper';

const htmlToComponents = new Parser().parse;

const SearchedPosts = ({
  t,
  loadMore,
  choosePost,
  searchedPosts,
  searchCriteria,
  hasMoreSearch,
}) => (
  <React.Fragment>
    {searchedPosts.length || (searchCriteria && searchCriteria.search) ?
      <InfiniteScroll
        loadMore={loadMore}
        hasMore={hasMoreSearch}
        pageStart={0}
        initialLoad={false}
        loader={<div className="loader" key={0}>{t('Loading')} ...</div>}
      >
        {searchedPosts.map(post => (
          <div className="kb2step kb2step1 boxs" key={post.id}>
            <div className="Blogs2 boxs srchpost">
              {post ?
                <div
                  className="BlogsBox boxs BlogsBoxkb imrtant-style"
                >
                  <h5 onClick={e => choosePost(e, post)} className="post-title">{htmlToComponents(post.title)}</h5>
                  {post.content && htmlToComponents(sh.replaceSpecialChars(post.content))}
                </div> :
                <div />
              }
            </div>
          </div>
                      ))}
      </InfiniteScroll> :
      <Redirect to="/kb" />
        }
  </React.Fragment>
);

SearchedPosts.propTypes = {
  t: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  choosePost: PropTypes.func.isRequired,
};

export default SearchedPosts;



// WEBPACK FOOTER //
// ./src/views/modules/kb/searchedPosts/SearchedPosts.jsx